import { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';
import { Link } from 'react-router-dom';

export const CookieConsent = () => {
  const { t, i18n } = useTranslation();
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const handleAccept = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const handleReject = () => {
    localStorage.setItem('cookieConsent', 'rejected');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  const currentLang = i18n.language;

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-background/95 backdrop-blur-sm border-t border-border p-4 md:p-6 z-50 shadow-lg">
      <div className="container mx-auto max-w-6xl">
        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
          <div className="flex-1">
            <p className="text-sm text-foreground mb-2">
              {t('cookie.message')}
            </p>
            <p className="text-xs text-muted-foreground">
              {t('cookie.learnMore')}{' '}
              <Link 
                to={`/${currentLang}/cookies`} 
                className="underline hover:text-foreground"
              >
                {t('cookie.cookiePolicy')}
              </Link>
              {' '}{t('cookie.and')}{' '}
              <Link 
                to={`/${currentLang}/privacy`} 
                className="underline hover:text-foreground"
              >
                {t('cookie.privacyPolicy')}
              </Link>
            </p>
          </div>
          <div className="flex gap-2 w-full md:w-auto">
            <Button 
              variant="outline" 
              onClick={handleReject}
              className="flex-1 md:flex-none"
            >
              {t('cookie.reject')}
            </Button>
            <Button 
              onClick={handleAccept}
              className="flex-1 md:flex-none"
            >
              {t('cookie.accept')}
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
